export enum STATE_TYPES {
  ERROR = 'error',
  ACCESS = 'access',
  EMPTY = 'empty',
  NO_RESULTS = 'no-results',
  SLEEP = 'sleep',
}

export enum STATE_SIZES {
  LARGE = 'large',
  MEDIUM = 'medium',
  SMALL = 'small',
}
